module.exports = __webpack_public_path__ + "img/sy.af79e511.svg";